<template>
  <ThumbButton
    class="ThumbButtonView"
    iconName="plus"
    aria-label="New"
    @click="isMenuVisible = true"
  >
    <Teleport to="body">
      <Transition>
        <MenuModal
          v-if="isMenuVisible"
          data-testid="thumbMenuModal"
          @close="isMenuVisible = false"
        >
          <MenuModalButton
            v-for="item in menuItems"
            :key="item.title"
            v-bind="item"
            @click="handleMenuItemClick(item)"
          />
        </MenuModal>
      </Transition>
    </Teleport>
  </ThumbButton>
</template>

<script setup lang="ts">
import { ModalMenuItem } from "@/components/MenuModal.types";
import MenuModal from "@/components/MenuModal.vue";
import MenuModalButton from "@/components/MenuModalButton.vue";
import ThumbButton from "@/components/ThumbButton.vue";
import { RouteName } from "@/lib/router/routes";
import useAuthStore from "@/stores/useAuthStore";
import useModalStore from "@/stores/useModalStore";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";

const {
  openModal,
} = useModalStore();

const isMenuVisible = ref(false);

const {
  isCommissioner,
} = storeToRefs(useAuthStore());

const menuItems = computed(() => {
  const playerItems: Array<ModalMenuItem> = [
    {
      id: "sendFeedback",
      iconName: "chatAlert",
      title: "Send feedback",
      subtitle: "Help me improve the app",
    },
  ];

  if (!isCommissioner.value) {
    return playerItems;
  }

  const commissionerItems: Array<ModalMenuItem> = [
    {
      id: "scheduleRun",
      iconName: "personRunning",
      title: "Schedule a run",
      subtitle: "Set up a time for your crew to play",
    },
    {
      id: "invitePlayer",
      iconName: "personWithArmsRaised",
      title: "Invite a player",
      subtitle: "Add someone to your crew",
    },
  ];

  return [...commissionerItems, ...playerItems];
});

function handleMenuItemClick (item: ModalMenuItem) {
  isMenuVisible.value = false;

  switch (item.id) {
    case "scheduleRun":
      openModal({ name: RouteName.runNew });
      break;
    case "invitePlayer":
      openModal({ name: RouteName.invitePlayer });
      break;
    case "startSeason":
      openModal({ name: RouteName.seasonNew });
      break;
    case "sendFeedback":
      openModal({ name: RouteName.feedback });
      break;
  }
}
</script>
